<template>
  <div>
    <div>
      <div class='row h-row-insertBox'>
        <div class='col-sm-12 h-col-insertBox'>
          <div class="h-inputLit">{{this.$t('选择交付类型')}}</div>
        </div>
      </div>
      <div class='row h-row-insertBox'>
        <div class='col-sm-2 h-col-insertBox'>
          <ejs-radiobutton class='h-inputLit' :label=deliverType[0].text name='DeliverRadio' checked='false'
                           :value=deliverType[0].value></ejs-radiobutton></div>
        <div class='col-sm-2 h-col-insertBox'>
          <ejs-radiobutton class='h-inputLit' :label='deliverType[1].text' name='DeliverRadio'
                           :value=deliverType[1].value></ejs-radiobutton></div>
        <div class='col-sm-2 h-col-insertBox'>
          <ejs-radiobutton class='h-inputLit' :label='deliverType[2].text' name='DeliverRadio'
                           :value=deliverType[2].value></ejs-radiobutton></div>
        <div class='col-sm-2 h-col-insertBox'>
          <ejs-radiobutton class='h-inputLit' :label='deliverType[3].text' name='DeliverRadio' :value=deliverType[3].value></ejs-radiobutton>
        </div>
      </div>
      <div class='row h-row-insertBox'>
        <div class='col-sm-6 h-col-insertBox'>
          <div class="h-inputLit">{{this.$t('选择分类')}}</div>
          <ejs-dropdownlist class="e-input" ref="typeList" :dataSource='dataSource' :index='0'></ejs-dropdownlist>
        </div>
      </div>
      <div class='row h-row-insertBox'>
        <div class='col-sm-6 h-col-insertBox'>
          <div class="h-inputLit">{{this.$t('上传软件包')}}</div>
          <ejs-button class="e-input" @click.native='upButton'>+上传</ejs-button>
        </div>
      </div>
      <div class='row h-row-insertBox'>
        <div class='col-sm-6 h-col-insertBox'>
          上传动画+删除按钮
        </div>
      </div>
      <div class='row h-row-insertBox' v-show='versionShow'>
        <div class='col-sm-6 h-col-inputBox'>
          <div class="h-inputLit">{{this.$t('选择适配包匹配版本')}}</div>
          <ejs-dropdownlist class="e-input e-disabled e-input-group" ref="versionList"
                            :dataSource='versionSource'></ejs-dropdownlist>
        </div>
      </div>
    </div>
    <div class='h-system-hide-upload'>
      <ejs-uploader ref='file' name='file' id='file' autoUpload='false' :selected='onFileSelect'
                    :multiple='false'></ejs-uploader>
    </div>
  </div>
</template>

<script>
  import { EventBus } from '../../../plugins/eventBus';

  export default {
    name: 'addDialog',
    data() {
      return {
        versionShow: false,
        dataSource: [
          {text: this.$t('基础'), value: 0},
          {text: this.$t('业务'), value: 1},
        ],
        deliverType: [
          {text: 'Native', value: 0},
          {text: 'Image', value: 1},
          {text: 'Helm', value: 2},
          {text: 'VM', value: 3}
        ],
        versionSource: [],
      }
    },
    methods: {
      upButton() {
        document
          .getElementsByClassName('e-file-select-wrap')[0]
          .querySelector('button')
          .click();
        return false;
      },
      onFileSelect(args) {
        const file = args.filesData;
        if (file[0].name.indexOf('.pkg') != -1) {
          // 上传3.0.100升级包特殊处理，必须选择适配包版本号
          this.versionShow = true;
          this.getVersionList();
        }
      },
      getVersionList() {
        // 获取适配包版本号
        const url = '/lte/ems/packageManager/queryService';
        this.axios.get(url).then(res => {
          console.log(res.data);
          const list = res.data.map(item => item.pkgVersion);
          this.versionSource = Array.from(new Set(list));
        });
      },
      getParam() {
        const index = this.$refs.versionList.ej2Instances.index;
        const version = this.versionSource[index];
        let type = 0;
        const radioGroup = document.getElementsByName('DeliverRadio');
        radioGroup.forEach(item => {
          if(item.checked) {
          type = item.ej2_instances[0].value;
          }
        });
        const file = this.$refs.file.ej2Instances.filesData[0];
        const param = {
          version: version,
          file: file['rawFile'],
          type: type
        };
        return param;
      },
      check() {
        const data = this.getParam();
        const file = data['file'];
        const version = data['version'];
        if (file.name.indexOf('.pkg') != -1 && version == null) {
          this.eventEmit('warning', '请选择适配包匹配版本号');
          return false;
        };
        return true;
      },
      // async upload() {
      //   const check = this.check();
      //   if (!check) {
      //     return null;
      //   }
      //   const exist = await this.checkExistPackage();
      //   this.$loading.showLoadding();
      //   if (exist) {
      //   //  存在直接解压
      //     this.againUpload();
      //   } else {
      //     this.firstUpload();
      //   }
      // },
      // async checkExistPackage(){
      //   const url = '/lte/ems/packageManager/isPackageExist';
      //   const data = this.getParam();
      //   const fileName = data['file']['name'];
      //   const params = {
      //     fileName: fileName
      //   };
      //   let exist = new Boolean();
      //   await this.axios.get(url, { params }).then(res => {
      //     exist = res.data;
      //   });
      //   return exist;
      // },
      // againUpload() {
      //   const url = '/lte/ems/packageManager/againUpload';
      //   const data = this.getParam();
      //   const fileName = data['file']['name'];
      //   const params = {
      //     fileName: fileName,
      //     adapterVersion: data['version']
      //   };
      //   this.axios.get(url, { params }).then(res => {
      //     setTimeout(
      //       this.getUploadResult(fileName),
      //       this.timeOut
      //     );
      //   });
      // },
      // firstUpload() {
      //   const data = this.getParam();
      //   const fileName = data['file']['name'];
      //   const url = '/lte/ems/packageManager/uploadPackage';
      //   const formData = new FormData();
      //   formData.append('type', data['type']);
      //   formData.append('file', data['file']);
      //   formData.append('version', data['version']);
      //   const config = {
      //     headers: {
      //       "Content-Type": "multipart/form-data"
      //     },
      //     timeout: 60 * 6 * 1000
      //   };
      //   this.axios.post(url, formData, config).then(res => {
      //     setTimeout(
      //       this.getUploadResult(fileName),
      //       this.timeOut
      //     );
      //   });
      // },
      // getUploadResult(fileName) {
      // //  轮询检查上传结果
      //   const url = '/lte/ems/packageManager/getUploadResult';
      //   const params = {
      //     fileName: fileName
      //   };
      //   this.$axios.get(url, { params }).then(res => {
      //     const success = res.data;
      //     if (success) {
      //       this.$loading.hideLoadding();
      //       this.getServiceList();
      //     } else {
      //       setTimeout(
      //         'this.getUploadResult(fileName)',
      //         this.timeOut
      //       );
      //     }
      //   });
      // },
      eventEmit(type, content) {
        EventBus.$emit('toast', {type: type, content: content})
      },
    },
  }
</script>
